import { render } from "./Ads.vue?vue&type=template&id=958688ba&scoped=true&ts=true"
import script from "./Ads.vue?vue&type=script&lang=ts"
export * from "./Ads.vue?vue&type=script&lang=ts"

import "./Ads.vue?vue&type=style&index=0&id=958688ba&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-958688ba"]])

export default __exports__